module.exports = __webpack_public_path__ + "img/21.0e6a5386.png";